<template>
  <popover-modal-post ref="popover" class="blog-popover">
    <template v-slot:header>
      <!-- Header content removed to prevent blocking text -->
    </template>
    <button
      class="blog-close-button"
      @click="closePopup"
      type="button">
      <i class="material-icons">close</i>
    </button>
    <blog-feed/>
  </popover-modal-post>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { getRootPath } from '../lib/bookmarks'
import PopoverModalPost from './components/UI/PopoverModalPost'
import BlogFeed from './BlogFeed'

export default {
  name: 'BlogPopover',
  components: { BlogFeed, PopoverModalPost },
  computed: {
    ...mapState(['user', 'viewCanToggleDrafts', 'showDraftsInGrid']),
    adminOrEditor () {
      return this.user && (this.user.role === 'admin' || this.user.role === 'editor')
    },
    messageToggleDrafts () {
      return this.showDraftsInGrid ? 'Hide Drafts' : `Show ${!this.adminOrEditor ? 'Mine ' : ''}Drafts`
    }
  },
  methods: {
    ...mapActions(['toggleDraftsInGrid']),
    closePopup () {
      if (this.$refs.popover) {
        this.$refs.popover.close()
      } else {
        const rootPath = getRootPath() || '/'
        this.$router.push(rootPath)
      }
    },
    scrollBlogUp () {
      const popover = this.$refs.popover
      if (popover && popover.$refs && popover.$refs.contentBox) {
        popover.$refs.contentBox.scrollBy({ top: -300, behavior: 'smooth' })
      } else {
        // Fallback: find the content box directly
        const contentBox = document.querySelector('.blog-popover .content-box')
        if (contentBox) {
          contentBox.scrollBy({ top: -300, behavior: 'smooth' })
        }
      }
    },
    scrollBlogDown () {
      const popover = this.$refs.popover
      if (popover && popover.$refs && popover.$refs.contentBox) {
        popover.$refs.contentBox.scrollBy({ top: 300, behavior: 'smooth' })
      } else {
        // Fallback: find the content box directly
        const contentBox = document.querySelector('.blog-popover .content-box')
        if (contentBox) {
          contentBox.scrollBy({ top: 300, behavior: 'smooth' })
        }
      }
    }
  }
}
</script>

<style lang="scss">
  @import "../styles/vars";

  .blog-close-button {
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
    z-index: 10002 !important;
    width: 2.5rem;
    height: 2.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.95);
    border: 1px solid #ddd;
    border-radius: 50%;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    transition: all 0.2s;

    @media (max-width: 30rem) {
      top: 0.5rem;
      right: 0.5rem;
      width: 2.5rem;
      height: 2.5rem;
      background: rgba(255, 255, 255, 0.95);
    }

    &:hover {
      background: white;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    }

    i {
      font-size: 1.2rem;
      color: #333;
    }
  }

  .blog-scroll-button {
    position: absolute;
    z-index: 10001 !important;
    width: auto;
    height: auto;
    min-width: auto;
    min-height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent !important;
    border: none !important;
    border-radius: 0 !important;
    cursor: pointer;
    box-shadow: none !important;
    padding: 0;
    margin: 0;
    transition: opacity 0.2s;
    left: 50%;
    transform: translateX(-50%);

    @media (max-width: 30rem) {
      display: none !important;
    }

    &:hover {
      opacity: 0.7;
      transform: translateX(-50%);
    }

    i {
      font-size: 1.5rem;
      color: #333;
    }

    &.blog-scroll-up {
      top: 4rem;
    }

    &.blog-scroll-down {
      bottom: 2rem;
    }
  }
</style>
